import { useMutation } from "@tanstack/react-query";
import { FilesService } from "../FilesService";

interface DownloadFileProps {
  path: string;
  fileName: string;
}

export const useDownloadFile = () => {
  const { isPending, mutateAsync: downloadFile } = useMutation({
    mutationFn: async ({ path, fileName }: DownloadFileProps) => {
      const response = await FilesService.openFile({ path });

      const blob = response.data;
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
    },
  });

  return { isPending, downloadFile };
};
